class User {
  /**
   * @param {Object} userData - Objeto con los datos del usuario
   */
  constructor({
    id,
    email,
    divisions = {},
    firstName,
    lastName,
    access = {},
    locale = 'es',
    password,
    idCard = null,
    birthDate = null,
    phone = null,
    flexTime = false,
    professionalEmail = null,
    job = null,
    externalUserInfo = null,
    timeZone,
    address,
  } = {}) {
    this.id = id;
    this.email = email;
    this.divisions = divisions;
    this.firstName = firstName;
    this.lastName = lastName;
    this.access = access;
    this.locale = locale;
    this.password = password;
    this.idCard = idCard;
    this.birthDate = birthDate;
    this.phone = phone;
    this.flexTime = flexTime;
    this.professionalEmail = professionalEmail;
    this.job = job;
    this.externalUserInfo = externalUserInfo;
    this.timeZone = timeZone;
    this.address = address;
  }

  setData(data) {
    this.id = data.id;
    this.email = data.email;
    this.divisions = data.divisions;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.access = data.access;
    this.locale = data.locale || 'es';
    this.password = data.password;
    this.idCard = data.idCard;
    this.birthDate = data.birthDate;
    this.phone = data.phone;
    this.flexTime = data.flexTime;
    this.professionalEmail = data.professionalEmail;
    this.job = data.job;
    this.externalUserInfo = data.externalUserInfo;
    this.timeZone = data.timeZone;
    this.address = data.address;
  }

  updateProfile() {
    return {
      email: this.email,
      firstName: this.firstName,
      lastName: this.lastName,
      phone: this.phone,
      locale: this.locale,
      timeZone: this.timeZone,
      idCard: this.idCard,
      birthDate: this.birthDate,
      ...(this.address !== undefined ? { address: this.address } : {}),
    };
  }

  static getFullName(user) {
    return `${user?.firstName} ${user?.lastName}`.trim();
  }
}

export default User;
